<mat-accordion>
  @let sharedLayersState = sharedLayersState$();
  <mat-expansion-panel
    [expanded]="sharedExpanded$()"
    [disabled]="sharedLayersState.status === 'loading'"
    (opened)="onPanelOpened()"
    (closed)="onPanelClosed()"
  >
    <mat-expansion-panel-header>
      <mat-panel-title class="layers-panel-title"> Shared layers </mat-panel-title>

      <mat-panel-description class="expansion-panel-loader">
        @if (sharedLayersState.status === 'loading') {
          <mat-spinner diameter="20"></mat-spinner>
        } @else {
          <button
            mat-icon-button
            [matMenuTriggerFor]="sortMenu"
            matTooltip="Sort"
            (click)="$event.stopPropagation()"
          >
            <mat-icon>swap_vert</mat-icon>
          </button>
          <mat-menu #sortMenu="matMenu">
            <button
              mat-menu-item
              [disabled]="sortSelected$() === 'name'"
              (click)="filterSharedLayer('name')"
            >
              <mat-icon>sort_by_alpha</mat-icon>
              Name
            </button>
            <button
              mat-menu-item
              [disabled]="sortSelected$() === 'oldToNew'"
              (click)="filterSharedLayer('oldToNew')"
            >
              <mat-icon>date_range</mat-icon>
              Old to new
            </button>
            <button
              mat-menu-item
              [disabled]="sortSelected$() === 'newToOld'"
              (click)="filterSharedLayer('newToOld')"
            >
              <mat-icon>event_repeat</mat-icon>
              New to old
            </button>
          </mat-menu>

          <button
            mat-icon-button
            (click)="refreshSharedLayers()"
            matTooltip="Refresh"
            (click)="$event.stopPropagation()"
          >
            <mat-icon>refresh</mat-icon>
          </button>
        }
      </mat-panel-description>
    </mat-expansion-panel-header>
    @switch (sharedLayersState.status) {
      @case ('loading') {
        <!-- nothing, loader in header -->
      }
      @case ('error') {
        <span class="no-data">
          Shared layers not available<br />
          Please, try again later.
        </span>
      }
      @case ('success') {
        <div class="layers-list">
          @if (filteredSharedLayers$().length > 0) {
            @for (layer of filteredSharedLayers$(); track layer.id) {
              <app-card-layer-shared [layer]="layer"></app-card-layer-shared>
            }
          } @else {
            No one has shared a layer with you.
          }
        </div>
      }
    }
  </mat-expansion-panel>
</mat-accordion>
